const HOUR_MS = 60 * 60 * 1000
const DAY_MS = 24 * HOUR_MS

function parseLeaveDateTime(value) {
  if (!value) return null
  const normalized = typeof value === 'string' ? value.replace(' ', 'T') : value
  const date = new Date(normalized)
  return Number.isNaN(date.getTime()) ? null : date
}

export function getLeaveDurationMs(startStr, endStr) {
  const start = parseLeaveDateTime(startStr)
  const end = parseLeaveDateTime(endStr)
  if (!start || !end) return 0
  return Math.max(0, end.getTime() - start.getTime())
}

export function getLeaveDurationDays(startStr, endStr) {
  return getLeaveDurationMs(startStr, endStr) / DAY_MS
}

export function formatLeaveDuration(startStr, endStr) {
  const durationMs = getLeaveDurationMs(startStr, endStr)
  if (!durationMs) return '0小时'

  const totalHours = Math.max(1, Math.ceil(durationMs / HOUR_MS))
  const days = Math.floor(totalHours / 24)
  const hours = totalHours % 24

  const parts = []
  if (days > 0) parts.push(`${days}天`)
  if (hours > 0 || parts.length === 0) parts.push(`${hours}小时`)

  return parts.join('')
}
